import React, { useState, useRef } from 'react';

//components
import SelectButtonList from  '@/components/elements/global/lists/SelectButtonList/SelectButtonList';
import Icon from  '@/components/elements/icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';

//hooks
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';



const SimpleTableMenu = ({ isControlIndex, setControlIndex, buttons }) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const ref = useRef<HTMLTableCellElement>(null);
    const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
        if (ref.current && !ref.current.contains(event.relatedTarget as Node)) {
          setShowMenu(false);
        }
    };

    useClickAwayClose(showMenu, ref, () => {setShowMenu(false)});

    return (
        <td className="control-cell" ref={ref} onBlur={handleBlur}>
            <button type='button' className="simple-table-menu" aria-label="Open menu" onClick={() => { setControlIndex(); setShowMenu(!showMenu)}}>
                <Icon iconName={IconLibrary.MENU_MORE} color="#343D4C" sizeInPx="12" />
            </button>

            {isControlIndex && showMenu && (<SelectButtonList className="simple-controls drag-and-drop-list" buttons={buttons ?? []} allButtonOnClick={() => setShowMenu(false)}/>)}
        </td>
    );
};

export default SimpleTableMenu;
